import '../css/musicplayer.css';
import * as m from "@magenta/music";
import { useEffect, useState } from 'react';

const VAEURL ="https://storage.googleapis.com/magentadata/js/checkpoints/music_vae/mel_4bar_small_q2"
// const VAEURL ="https://storage.googleapis.com/magentadata/js/checkpoints/music_vae/mel_2bar_small"
// const VAEURL ="https://storage.googleapis.com/magentadata/js/checkpoints/music_vae/trio_4bar"
var music = 0;
var PLAYER = 0;
const MusicPlayer = ({ mood }) => {
    const statusCSS = (type) => {
        const _status = document.getElementById("statusID");
        if (!type)
            return _status.classList.remove("blink")
       else if (type == "Negative")
            return _status.style.color = "#decd00";
        else if (type == "Positive") {
            return _status.style.color = "#27bf27";
        }
        else if (type == "Neutral")
            return _status.style.color = "#e68002";
    };
    const LoadMusic = async () => {
        music = await new m.MusicVAE(VAEURL);
        await music.initialize();
        PLAYER = new m.Player();
        await setStatus("Play!");
        await statusCSS(false);
    };

    useEffect(() => {
        LoadMusic();
    }, []);

    const [status, setStatus] = useState("Loading Model...");
    const tooglePlay = () => {

        const disc = document.getElementById("disc");
        if (disc.classList.contains("image")) {
            setStatus("Click to Play!");
            PLAYER.stop();
            return disc.classList.remove("image");
        }

        music.sample(1, 0.5)
            .then((sample) => {
                setStatus(mood ? mood : "Random");
                statusCSS(mood);
                PLAYER.start(sample[0]);
                disc.classList.add("image");
            });

    };

    return (
        <div className="musicplayer_"
            onClick={tooglePlay} >
            <div className="disc" id="disc" >
            </div>
            <div className="display">
                <div className="heading blink" id="statusID">
                    {status}
                </div>
                <div className="composer">
                    "Music by Riddim Ai"
                </div>

            </div>

        </div>
    );
};

export default MusicPlayer;